import styled from 'styled-components'
import { Image, Modal, Button, Form, Input, Select, Radio, Space, Typography } from 'antd'
import DOMPurify from 'dompurify'
import { useState, useEffect, useMemo } from 'react'
import { SignTitle, SearchInput, Warning } from '@/components'
import { useCheditor } from '@/utils'
import { useCallback } from 'react'
import { useDebounceFn } from 'ahooks'
import { SvgIcon } from '../svg-icon'
import AiContentEmpty from '@/assets/imges/phishing/create/bg_ai_empty.png'
import { modifyHtmlString, useGetSecyTemplate } from './utils'
import { block } from '@antv/x6/lib/registry/marker/classic'
import { t } from '@/i18n'
const { useForm } = Form
const { Option } = Select

export const AiMailModal = props => {
  const {
    visible,
    onCancel,
    onConfirm,
    placeholder,
    inputSearch,
    submitLoading,
    searchLoading,
    // 1：默认，创建任务第三步Ai生成邮件 2：创建任务第五步Ai生成钓鱼邮件
    // 3：邮件模板tab，AI生成模板 4：钓鱼页模板，AI生成模板
    modalType = '1',
    selectEmailType = 'EmailTypeLink',
    subject = '',
    templateList = [],
    getPhishing = {},
    getAttachmentsList = {},
  } = props
  const [getSecyTemplate, getSecyTemplateLoading, securityTemplateList] = useGetSecyTemplate()
  const [createForm] = useForm()
  const [element, setElement] = useState<HTMLDivElement | null>(null)
  let [content, setContent] = useState('')
  let [resList, setResList] = useState([])
  const [selected, setSelected] = useState({ id: '', content: '', subject: '' })
  const [emailType, setEmailType] = useState(selectEmailType) // EmailTypeLink: email  EmailTypeAttachment: attachment
  const [type, setType] = useState('0')
  const [searchValue, setSearchValue] = useState({
    subject: subject,
    message1: '',
    message2: '',
    emailType: emailType,
  })
  const { editor, status } = useCheditor({
    height: 300,
    initData:
      JSON.parse(localStorage.getItem('aiEmailText'))?.id === selected?.id
        ? JSON.parse(localStorage.getItem('aiEmailText'))?.content
        : '',
    element,
    onChange: e => {
      console.log('e', e)
      localStorage.setItem(
        'aiEmailText',
        JSON.stringify({
          content: e,
          id:
            JSON.parse(localStorage.getItem('aiEmailText'))?.id === selected
              ? JSON.parse(localStorage.getItem('aiEmailText'))?.id
              : selected.id,
        }),
      )
      run(e)
    },
  })

  useEffect(() => {
    editor?.setData(selected?.content)
  }, [selected?.content])

  const modifyHtmlTemplate = useMemo(
    () =>
      templateList.map(item => ({
        ...item,
        content: modifyHtmlString(item.content),
      })),
    [templateList],
  )

  useEffect(() => {
    if (modifyHtmlTemplate.length > 0) {
      selectMailItem(modifyHtmlTemplate[0])
    }
  }, [modifyHtmlTemplate])

  useEffect(() => {
    if (modalType === '2') {
      console.log(1111111111)
      createForm.setFieldsValue({ name: subject })
    }
  }, [modalType])

  const { run } = useDebounceFn(
    value => {
      setContent(value)
      const regs = /<a .*?href="(.*?)">.*?<\/a>/gim
      setResList((resList = value.match(regs)))
      if (!value.match(regs) || value.match(regs)?.length === 0) {
        createForm.setFieldsValue({ link: undefined })
      }
    },
    {
      wait: 500,
    },
  )

  const onFinish = values => {
    let value = editor?.getData()
    // setContent(value)
    console.log(value)
    if (
      content === '<html>\n<head>\n\t<title></title>\n</head>\n<body></body>\n</html>' ||
      content === '' ||
      content.trim() === ''
    )
      return
    let arr = []
    console.log(111, emailType)
    if (emailType === 'EmailTypeLink' && (modalType === '1' || modalType === '3')) {
      if (!resList || resList?.length === 0) {
        return
      }
      resList?.map(item => {
        const reg2 = /href=\"([^\"]+)/gim
        const reg3 = />(.*)<\/a>/gim
        const reg4 = /(?<=>)(.|\s)*?(?=<\/?\w+[^<]*>)/gim
        const links = item.match(reg2)
        const urls = links?.[0]?.slice(links?.[0]?.indexOf('=') + 2)
        if (urls === values.link) {
          value = value.replaceAll(urls, `{{.Url}}`)
          arr.push(item.match(reg3)[0].match(reg4).join(''))
        }
      })
    }
    onConfirm({ ...values, emailType, link: emailType === 'EmailTypeLink' ? arr[0] : '' }, () => {
      createForm.resetFields()
      localStorage.removeItem('aiEmailText')
      localStorage.removeItem('aiEmailTemplate')
      setSearchValue({ subject: subject, message1: '', message2: '' })
    })
  }

  const selectMailItem = item => {
    setSelected(item)
    createForm.setFieldsValue({ subject: item.subject, name: item.subject || item.name })
    if (status === 'ready') {
      console.log(333)
      localStorage.setItem('aiEmailText', JSON.stringify({ id: item.id, content: item.content }))
      run(item.content)
    }
  }

  return (
    <ModalItem
      title={
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          <SignTitle show style={{ width: 300 }}>
            {modalType === '1' || modalType === '3' ? t('AI生成邮件模板') : t('AI生成钓鱼页模板')}
          </SignTitle>
        </div>
      }
      visible={visible}
      centered
      destroyOnClose
      mask
      width={1000}
      onOk={() => createForm.submit()}
      onCancel={() => {
        createForm.resetFields()
        localStorage.removeItem('aiEmailText')
        localStorage.removeItem('aiEmailTemplate')
        setType('0')
        onCancel()
        setSearchValue({ subject: subject, message1: '', message2: '' })
      }}
      bodyStyle={{ height: 600 }}
      footer={
        <div style={{ display: 'flex', paddingRight: '10px', justifyContent: 'flex-end' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ color: 'red' }}>*</span>
            {modalType === '1' || modalType === '3'
              ? t('点击【保存】，该模版将自动创建存入邮件模板库')
              : t('点击【保存】，该模版将自动创建存入钓鱼页模板库')}
          </div>
          <div style={{ display: 'flex', marginLeft: 16 }}>
            <Button
              onClick={() => {
                createForm.resetFields()
                onCancel()
                setType('0')
              }}
            >
              {t('取消')}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                createForm.submit()
              }}
              loading={submitLoading}
            >
              {t('保存')}
            </Button>
          </div>
        </div>
      }
    >
      <div className="mailBox">
        <MailListBox>
          <div className="search-box">
            {(modalType === '2' || modalType === '4') && (
              <>
                <div style={{ marginBottom: 16 }}>
                  <Input
                    type="text"
                    placeholder={t('请输入邮件主题描述')}
                    value={searchValue.subject}
                    maxLength={100}
                    onChange={e => {
                      const { message1, message2 } = searchValue
                      setSearchValue({ subject: e.target.value, message1, message2, type: '' })
                    }}
                  />
                </div>
                <div style={{ marginBottom: 16, width: 'calc(100% - 118px)' }}>
                  <Input
                    type="text"
                    placeholder={t('账号')}
                    value={searchValue.message1}
                    maxLength={20}
                    onChange={e => {
                      const { subject, message2 } = searchValue
                      setSearchValue({ subject, message1: e.target.value, message2, type: '' })
                    }}
                  />
                </div>
                <div style={{ width: '100%', justifyContent: 'flex-start', display: 'flex' }}>
                  <div style={{ width: '300px', marginBottom: 16, marginRight: 8, flex: 1 }}>
                    <Input
                      type="text"
                      placeholder={t('密码')}
                      value={searchValue.message2}
                      maxLength={20}
                      onChange={e => {
                        const { subject, message1 } = searchValue
                        setSearchValue({ subject, message1, message2: e.target.value, type: '' })
                      }}
                    />
                  </div>

                  <Button
                    type="primary"
                    loading={searchLoading}
                    className="ai-btn"
                    style={{
                      background: 'linear-gradient( 174deg, #2090A8 0%, #4F4FAE 100%)',
                      border: 'none',
                      width: '110px',
                      opacity: searchValue.subject ? 1 : 0.5,
                      cursor: searchValue.subject ? 'pointer' : 'not-allowed',
                    }}
                    onClick={() => {
                      if (!searchValue.subject) return
                      createForm.setFieldValue('content', content)
                      inputSearch(searchValue)
                    }}
                  >
                    {t('AI生成')}
                  </Button>
                </div>
              </>
            )}
            {modalType === '3' && (
              <>
                <div style={{ marginBottom: 16, marginRight: 8, flex: 1 }}>
                  <Input
                    type="text"
                    placeholder={placeholder}
                    maxLength={100}
                    onChange={e => {
                      setSearchValue({ subject: e.target.value, emailType })
                    }}
                  />
                </div>
                <div>{t('邮件模板类型')}</div>
                <div
                  style={{
                    width: '100%',
                    justifyContent: 'flex-start',
                    display: 'flex',
                    marginTop: 8,
                  }}
                >
                  <Select
                    defaultValue={emailType}
                    onChange={e => {
                      console.log(e)
                      setSearchValue({ subject: searchValue.subject, emailType: e })
                      setEmailType(e)
                    }}
                    style={{ flex: 1, marginBottom: 16, marginRight: 8 }}
                  >
                    <Select.Option value="EmailTypeLink">{t('钓鱼链接')}</Select.Option>
                    <Select.Option value="EmailTypeAttachment">{t('恶意附件')}</Select.Option>
                  </Select>
                  <Button
                    type="primary"
                    loading={searchLoading}
                    className="ai-btn"
                    style={{
                      background: 'linear-gradient( 174deg, #2090A8 0%, #4F4FAE 100%)',
                      border: 'none',
                      width: '110px',
                      opacity: searchValue.subject ? 1 : 0.5,
                      cursor: searchValue.subject ? 'pointer' : 'not-allowed',
                    }}
                    onClick={() => {
                      if (!searchValue.subject) return
                      createForm.setFieldValue('content', content)
                      inputSearch(searchValue)
                    }}
                  >
                    {t('AI生成')}
                  </Button>
                </div>
              </>
            )}
            {modalType === '1' && (
              <>
                <div style={{ width: '100%', justifyContent: 'flex-start', display: 'flex' }}>
                  <div style={{ marginBottom: 16, marginRight: 8, flex: 1 }}>
                    <Input
                      type="text"
                      placeholder={placeholder}
                      maxLength={100}
                      onChange={e => {
                        setSearchValue({ subject: e.target.value })
                      }}
                    />
                  </div>

                  <Button
                    type="primary"
                    loading={searchLoading}
                    className="ai-btn"
                    style={{
                      background: 'linear-gradient( 174deg, #2090A8 0%, #4F4FAE 100%)',
                      border: 'none',
                      width: '110px',
                      opacity: searchValue.subject ? 1 : 0.5,
                      cursor: searchValue.subject ? 'pointer' : 'not-allowed',
                    }}
                    onClick={() => {
                      if (!searchValue.subject) return
                      createForm.setFieldValue('content', content)
                      inputSearch(searchValue)
                    }}
                  >
                    {t('AI生成邮件')}
                  </Button>
                </div>
              </>
            )}

            <div
              className="mail-content"
              style={{
                height:
                  modalType === '2' || modalType === '4'
                    ? '380px'
                    : modalType === '3'
                    ? '406px'
                    : '480px',
              }}
            >
              {templateList.length > 0 ? ( //modifyHtmlTemplate templateList
                templateList.map((item, index) => (
                  <MailItemBox
                    key={index}
                    className={selected?.id === item.id ? 'active' : ''}
                    onClick={() => {
                      selectMailItem(item)
                      console.log(111111)
                    }}
                  >
                    {/* <div dangerouslySetInnerHTML={{ __html: item.content }} /> */}
                    <div style={{ position: 'relative' }}>
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          right: 0,
                          width: '100%',
                          height: '100%',
                        }}
                      />

                      <iframe
                        src={`data:text/html,${encodeURIComponent(item.content)}`}
                        frameborder="no"
                        border="0"
                        marginwidth="0"
                        marginheight="0"
                        scrolling="no"
                        width={'100%'}
                        height={'100%'}
                      />
                    </div>
                  </MailItemBox>
                ))
              ) : (
                <div className="empty">
                  <img src={AiContentEmpty} alt="" />
                  <div className="text">{t('暂无AI生成哦！')}</div>
                </div>
              )}
            </div>
          </div>
        </MailListBox>
        <MailFormBox>
          <FormItem onFinish={onFinish} form={createForm}>
            <div className="title">{t('模板预览')}</div>
            <Form.Item
              name="name"
              label={t('模板名称')}
              rules={[
                { required: true, message: t('请输入模板名称') },
                { max: 30, message: t('模板名称最多30个字') },
                {
                  pattern: /^(?=.*\S).+$/,
                  message: t('模板名称不能全部为空格!'),
                },
              ]}
            >
              <Input placeholder={t('请输入')} maxLength={30} />
            </Form.Item>
            {(modalType === '1' || modalType === '3') && (
              <>
                <Form.Item name="sender" label={t('发件昵称')} rules={[{ max: 64 }]}>
                  <Input placeholder={t('请输入')} maxLength={64} />
                </Form.Item>
                <div className="subject">
                  <Form.Item
                    name="subject"
                    label={t('邮件主题')}
                    className="main-body"
                    rules={[
                      { required: true, message: t('请输入邮件主题') },
                      { max: 100, message: t('邮件主题最多100字') },
                    ]}
                  >
                    <Input placeholder={t('请输入')} maxLength={100} />
                  </Form.Item>
                </div>
              </>
            )}
            {(modalType === '4' || modalType === '2') && (
              <>
                <Form.Item name="security_id" label={t('重定向页面')} initialValue={'0'}>
                  <Radio.Group
                    onChange={e => {
                      setType(e.target.value)
                      createForm.setFieldValue('redirect', null)
                    }}
                  >
                    <Radio value="0"> {t('输入自定义URL')} </Radio>
                    <Radio
                      value="1"
                      onClick={async () => {
                        try {
                          await getSecyTemplate({ limit: 9999, page: 1, keyword: '' })
                        } catch (error) {}
                      }}
                    >
                      {t('选择安全教育模板')}
                    </Radio>
                  </Radio.Group>
                </Form.Item>
                {type === '0' && (
                  <Form.Item
                    name="redirect"
                    // label="重定向页面"
                    rules={[{ type: 'url', message: t('请输入正确的重定向页面') }]}
                  >
                    <Input placeholder="https://example.com" />
                  </Form.Item>
                )}
                {type === '1' && (
                  <Form.Item
                    name="redirect"
                    // label="重定向页面"
                    // rules={[{ type: 'url', message: '请输入正确的重定向页面' }]}
                  >
                    <Select
                      optionFilterProp="label"
                      placeholder={t('请选择安全教育模板')}
                      options={securityTemplateList?.map(item => ({
                        label: `${item.name}(${item.redirect})`,
                        value: item.id,
                      }))}
                    />
                  </Form.Item>
                )}
                <Warning
                  text={t(
                    '可输入自定义URL或选择系统内置的安全教育模板作为重定向页面，并将钓鱼页面代码中的重定向页面URL改为{{.Url}}',
                  )}
                  style={{ width: 451, marginBottom: 16 }}
                />
              </>
            )}
            <div>
              <span style={{ color: '#ff4d4f', width: 11 }}>*</span>
              <span>{modalType === '1' || modalType === '3' ? t('邮件正文') : t('钓鱼页')}</span>
            </div>
            <div style={{ width: '100%', marginTop: 8 }}>{visible && <div ref={setElement} />}</div>
            {(content === '<html>\n<head>\n\t<title></title>\n</head>\n<body></body>\n</html>' ||
              content === '') && (
              <div style={{ color: '#ff4d4f', marginTop: 8, fontSize: 12 }}>
                {t('请输入')}
                {modalType === '1' || modalType === '3' ? t('邮件正文') : t('钓鱼页')}
                {t('内容')}
              </div>
            )}

            {(modalType === '1' || modalType === '3') && emailType === 'EmailTypeLink' && (
              <>
                <SelectLink>
                  <Form.Item
                    label={t('请选择更改为钓鱼页的链接')}
                    name="link"
                    className="phishing"
                    rules={[{ required: true }]}
                    style={{ display: 'block' }}
                  >
                    <Radio.Group>
                      <Space direction="vertical">
                        {resList?.map((item, index) => {
                          const reg2 = /href=\"([^\"]+)/gim
                          const reg3 = /<a[^>]*href=['"]([^"]*)['"][^>]*>(.*?)<\/a>/gim
                          const reg4 = /(?<=>)(.|\s)*?(?=<\/?\w{0,}[^<]*>)/gim
                          const link = item.match(reg2)
                          const urls = link?.[0]?.slice(link?.[0]?.indexOf('=') + 2)
                          const url = item.match(reg3)
                          return (
                            <Radio value={urls} key={index}>
                              <Typography.Text style={{ width: 200 }} ellipsis>
                                {url[0].match(reg4)?.join('')}
                              </Typography.Text>
                            </Radio>
                          )
                        })}
                      </Space>
                    </Radio.Group>
                    {/* </Checkbox.Group> */}
                  </Form.Item>
                </SelectLink>
                <Form.Item
                  name="templateId"
                  label={t('钓鱼页模板')}
                  className="template"
                  // rules={[{ required: true, message: '请选择钓鱼页模板' }]}
                >
                  <Select placeholder={t('请选择')}>
                    {getPhishing?.items?.length > 0 &&
                      getPhishing?.items?.map(item => (
                        <Option value={item.id} key={item.id}>
                          {item.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </>
            )}
            {(modalType === '1' || modalType === '3') && emailType === 'EmailTypeAttachment' && (
              <Form.Item
                name="templateId"
                label={t('附件模板')}
                // rules={[{ required: true, message: '请选择附件模板' }]}
                style={{ marginTop: 16 }}
              >
                <Select placeholder={t('请选择')}>
                  {getAttachmentsList?.items?.map(item => (
                    <Option value={item.id} key={item.id}>
                      {item.attachment_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </FormItem>
        </MailFormBox>
      </div>
    </ModalItem>
  )
}

const ModalItem = styled(Modal)`
  width: 1100px;
  height: 600px;
  .mailBox {
    display: flex;
    align-items: center;
  }
  .ant-modal-body {
    padding-top: 0;
    height: 580px;
  }
`

const MailFormBox = styled.div`
  height: 555px;
  width: 460px;
  overflow-y: scroll;
  flex: 1;
  padding-left: 16px;
  .ant-form-item-label {
    width: 80px;
    text-align: right;
  }
  .ant-form-item-control {
    flex: 1 !important;
  }
  .title {
    margin: 20px 0 24px 10px;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
  }
`
const FormItem = styled(Form)`
  padding-right: 0px;
`

const MailListBox = styled.div`
  width: 460px;
  height: 550px;
  flex: 1;
  padding-right: 16px;
  padding-top: 27px;
  border-right: 1px dashed #d5d9dd;
  .search-box {
    .mail-content {
      width: 100%;
      height: 480px;
      overflow-y: scroll;
      background: #f7f8fa;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 10px 0;
      box-sizing: border-box;
      .active {
        border: 2px solid #1890ff;
      }
      .empty {
        width: 171px;
        height: 143px;
        margin: 0 auto;
        .text {
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 400;
          font-size: 16px;
          color: #999999;
          line-height: 24px;
          text-align: center;
          font-style: normal;
        }
      }
    }
  }
  .ant-btn.ai-btn:hover {
    background: linear-gradient(45deg, #2090a8 0%, #4f4fae 100%) !important;
  }
`

const MailItemBox = styled.div`
  margin: 0 auto;
  border-radius: 8px;
  height: calc(50% - 30px);
  overflow-y: scroll;
  border: 1px solid #d5d9dd;
  width: calc(50% - 18px);
  margin: 10px 6px;
  box-sizing: border-box;
  :hover {
    transition: all 0.3s;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
    transform: scale(1.01);
    cursor: pointer;
  }
`
const SelectLink = styled.div`
  .phishing {
    .ant-form-item-row {
      display: flex;
      flex-direction: column;
    }
  }
  .ant-form-item-label {
    width: auto;
    text-align: left;
  }
`
